// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrashLineOutlinedSvg from "@fishx/icons-svg/es/asn/TrashLineOutlined";
import FishxIcon from '../components/FishxIcon';

var TrashLineOutlined = function TrashLineOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrashLineOutlinedSvg
  }));
};

TrashLineOutlined.displayName = 'TrashLineOutlined';
export default React.forwardRef(TrashLineOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrashLineOutlined.js
// module id = 4288
// module chunks = 0